module.exports = __webpack_public_path__ + "img/plus_corp.b2a0b76a.png";